import * as _ from "lodash";
import * as React from "react";
import * as S from "@styled";
import { notificationStorageKey } from "../App";
import { IAppReducerState } from "../shared/model";
import styled from "styled-components";
import useUserTheme from "shared/styles/hooks/useUserTheme";
import theme from "styled-theming";
import { ThemeType } from "shared/styles/theme";

const alertBackgroundColor = theme("mode", {
    [ThemeType.light]: "#FFF9E4",
    [ThemeType.dark]: "#615F4D"
})

const alertBorderColor = theme("mode", {
    [ThemeType.light]: "#FFD338",
    [ThemeType.dark]: "#C7C39D"
})

const alertColor = theme("mode", {
    [ThemeType.light]: "#7D5A00",
    [ThemeType.dark]: "#FFD182"
})

export const StyledNotificationAlert = styled.div`
    background: ${alertBackgroundColor};
    border: 1px solid ${alertBorderColor};
    border-radius: 2px;
    padding: 14px;
    color: ${alertColor};
    margin-bottom: 10px;
`


const NotificationMessageNotifier: React.FC<INotificationMessageNotifierProps> = (props) => {

    const { appState, dispatch } = props.state;

    const updateLocalStorage = (messages: INotificationMessage[]) => {
        if (typeof (Storage) !== "undefined") {
            const messageStatuses: INotificationMessageViewedStatus[] =
                (messages || []).map((msg) => ({ id: msg.id, viewed: msg.viewed }));

            localStorage.setItem(notificationStorageKey, JSON.stringify(messageStatuses));
        }
    };

    const getMessagesToUpdate = (): INotificationMessage[] => {
        if (!appState.notificationMessages || appState.notificationMessages.length < 1) {
            return [];
        }
        // create clone of the messages
        // quicker than _.cloneDeep, safe because the messages are serializable anyways
        return JSON.parse(JSON.stringify(appState.notificationMessages));
    };

    const handleDismiss = (id: string) => {
        const updatedMessages = getMessagesToUpdate();
        const message = updatedMessages.find((msg) => msg.id === id);
        if (message) {
            message.viewed = true;
        }

        // message viewed states changed => update local storage
        updateLocalStorage(updatedMessages);
        dispatch({ type: "SET_NOTIFICATION_MESSAGES", notificationMessages: updatedMessages });

    };

    const notificationMessages = appState.notificationMessages.filter((msg) => !msg.viewed);

    return (
        <div>
            {notificationMessages.map((message, idx) => (
                <NotificationMessageViewer
                    key={message.id}
                    message={message.message}
                    messageId={message.id}
                    onDismiss={handleDismiss}
                    index={idx}
                />
            ))}
            {(!_.isEmpty(appState.notificationMessages) && appState.notificationMessages.some((s) => s.viewed !== true)) && <hr style={{ margin: "15px 0", borderTopColor: "lightgrey" }} />}
        </div>
    );
};

const NotificationMessageViewer: React.FC<INotificationMessageViewerProps> = (props) => {
    const [theme] = useUserTheme();
    const handleDismissClick = (evt: React.MouseEvent) => {
        evt.stopPropagation(); // Stop propagation so that the notification popover don't get outsideClick events
        props.onDismiss(props.messageId);
    };

    return (
        <StyledNotificationAlert className="notification-alert-selector">
            <S.FlexContainer justifySpaceBetween={true} style={{ marginBottom: "10px" }}>
                <b>Warning</b>
                <i className="ci-close_big pointer" style={{ color: theme === "light" ? S.Colors.grey_1 : S.Colors.white }} onClick={handleDismissClick} id={`dismiss-notification-${props.index}`} />
            </S.FlexContainer>
            <S.FlexContainer>
                <span>{props.message}</span>
            </S.FlexContainer>
        </StyledNotificationAlert>
    );
};

export default NotificationMessageNotifier;

export interface INotificationMessage extends INotificationMessageViewedStatus {
    message: string;
}

export interface INotificationMessageViewedStatus {
    id: string;
    viewed: boolean;
}

export interface INotificationMessageViewerState {
    messages: INotificationMessage[];
}
export interface INotificationMessageViewerProps {
    messageId: string;
    message: string;
    onDismiss: (id: string) => void;
    index: number;
}

interface INotificationMessageNotifierProps {
    state: IAppReducerState;
}
